__turbopack_context__.v({
  "label": "JU-1-G_label",
  "label__badge": "JU-1-G_label__badge",
});
